import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-238be41c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "provision_contents_wrapper" }
const _hoisted_2 = { class: "provision_button" }
const _hoisted_3 = { class: "provision_button" }

import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import ProvisionConfirm from '@/components/ProvisionConfirm.vue';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvisionconfirmView',
  setup(__props) {

const router = useRouter();
const store = useStore();
const isLoading = ref(false);

const provision = computed(() => {
  return store.getters['provision/provision'];
});

const changeDateConvert = computed(() => store.getters['provision/changeDateConvert']);


const send = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('provision/send');
  } finally {
    isLoading.value = false;
  }
  router.replace({ name: 'f00' });
};

const back = () => {
  router.push({ name: 'n10' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ProvisionConfirm, {
        provision: _unref(provision),
        changeDateConvert: _unref(changeDateConvert)
      }, null, 8, ["provision", "changeDateConvert"]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseButton, { onClick: send }, {
          default: _withCtx(() => [
            _createTextVNode("この内容で登録する")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: back
        }, {
          default: _withCtx(() => [
            _createTextVNode("修正する")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})